<template>
  <b-form class="form-horizontal" @submit="saveContact">
    <div v-show="steps[step] === 'main'">
      <b-form-group label="Salutation" label-class="control-label form-label">
        <b-form-input v-model="form.salutation" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="First Name" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.firstName.$error }">
        <b-form-input v-model="form.firstName" type="text" :class="{ 'is-invalid': $v.form.firstName.$error}"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.firstName.$error">You must enter a first name.</span>
      </b-form-group>

      <b-form-group label="Last Name" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.lastName.$error }">
        <b-form-input v-model="form.lastName" type="text" :class="{ 'is-invalid': $v.form.lastName.$error}"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.lastName.$error">You must enter a last name.</span>
      </b-form-group>

      <b-form-group label="Title" label-class="control-label form-label">
        <b-form-input v-model="form.title" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Department" label-class="control-label form-label">
        <b-form-input v-model="form.department" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Phone Number" label-class="control-label form-label">
        <b-form-input v-model="form.phoneNumber" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Address" label-class="control-label form-label">
        <b-form-input v-model="form.address" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="City" label-class="control-label form-label">
        <b-form-input v-model="form.city" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="State" label-class="control-label form-label">
        <b-form-input v-model="form.state" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Zip Code" label-class="control-label form-label">
        <b-form-input v-model="form.zipCode" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Email" label-class="control-label form-label">
        <b-form-input v-model="form.email" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label="Contact Type" label-class="control-label form-label">
        <b-form-select :options="contactTypeOptions" v-model="form.contactTypeId" 
                      value-field="id"
                      text-field="name">
          <template slot="first">
            <b-form-select-option :value="null"></b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Notes" label-class="control-label form-label">
        <b-form-textarea :rows="3" placeholder="Enter notes..." v-model="form.notes"></b-form-textarea>
      </b-form-group>
    </div>

    <div v-show="steps[step] === 'awards'">
      <p>Select any awards associated with this contact.</p>
      <b-form-group label="Award Selection" label-class="control-label">
        <autocomplete :source="awardOptionsCopy"
                      inputClass="form-control"
                      placeholder="Search awards"
                      resultsValue="id"
                      :resultsDisplay="awardDisplay"
                      ref="awardAutocomplete"
                      clearAfterEntry
                      @selected="selectAward"></autocomplete>
      </b-form-group>
      <p v-if="!form.awards || form.awards === null|| form.awards.length === 0"><i>No awards have been selcted yet.</i></p>
      <div v-for="award in form.awards" :key="award.id" class="award-list mb-2">
        <b-badge variant="primary" class="award-badge" @click="removeAward(award)">
          <font-awesome-icon icon="times" /> {{ award.awardTitle + " (" + award.awardNumber + ")" }}
        </b-badge>
      </div>
    </div>

    <!-- <div v-show="steps[step] === 'projects'">
      <p>Select any projects associated with this contact.</p>
      <b-form-group label="project Selection" label-class="control-label">
        <autocomplete :source="projectOptionsCopy"
                      inputClass="form-control"
                      placeholder="Search projects"
                      resultsValue="id"
                      :resultsDisplay="projectDisplay"
                      ref="projectAutocomplete"
                      clearAfterEntry
                      @selected="selectproject"></autocomplete>
      </b-form-group>
      <p v-if="form.projects.length == 0"><i>No projects have been selcted yet.</i></p>
      <div v-for="project in form.projects" :key="project.id" class="project-list mb-2">
        <b-badge variant="primary" class="project-badge" @click="removeproject(project)">
          <font-awesome-icon icon="times" /> {{ project.projectTitle + " (" + project.projectNumber + ")" }}
        </b-badge>
      </div>
    </div> -->

    <div v-show="steps[step] === 'communityPartner'">
      <p>Select the community partnership this contact is affiliated with.</p>
      <b-form-group label="Community Partnerships" label-class="control-label"  :class="{ 'invalid-group': $v.form.communityPartner.$error }">
        <autocomplete :source="communityPartnerOptions"
                      placeholder="Search community partnerships"
                      resultsValue="id"
                      resultsDisplay="name"
                      ref="communityPartnerAutocomplete"
                      @selected="selectCommunityPartner"
                      :inputClass="{ 'form-control': true, 'is-invalid': $v.form.communityPartner.$error }"
                      :initialDisplay="communityPartnerInitialDisplay">
        </autocomplete>
        <span class="span-feedback invalid-feedback" v-if="$v.form.communityPartner.$error">You must select a community partner.</span>
      </b-form-group>
    </div>

    <div class="modal-footer">
      <b-btn variant="secondary" @click="cancel">Cancel</b-btn>
      <b-btn variant="primary" @click="next" v-if="step < steps.length - 1">Next</b-btn>
      <b-btn variant="secondary" @click="step--" v-if="step > 0" class="float-left">Back</b-btn>
      <b-btn type="submit" variant="primary" v-if="step >= steps.length - 1">Save</b-btn>
    </div>
  </b-form>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Autocomplete from "../../components/autocomplete";

export default {
  data() {
    return {
      form: {
        salutation: null,
        firstName: null,
        lastName: null,
        title: null,
        department: null,
        phoneNumber: null,
        address: null,
        city: null,
        state: null,
        zipCode: null,
        email: null,
        communityPartner: null,
        awards: [],
        projects: [],
        proposals: []
      },
      step: 0,
      awardOptionsCopy: [],
      communityPartnerInitialDisplay: ""
    };
  },

  props: {
    contact: {
      type: Object,
      required: false
    },
    awardOptions: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    contactTypeOptions: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    communityPartnerOptions: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    includeAwardsTab: {
      type: Boolean,
      required: false,
      default: false
    },
    includeCommunityPartnersTab: {
      type: Boolean,
      required: false,
      default: false
    },
    steps: {
      type: Array,
      required: false,
      default: function() {
        return ["main"];
      }
    }
  },

  components: {
    Autocomplete
  },

  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      communityPartner: {
        required: requiredIf(function() {
          return this.steps.includes("communityPartner");
        })
      }
    }
  },

  methods: {
    next: function() {
      if (this.steps[this.step] == "main") {
        this.$v.form.firstName.$touch();
        this.$v.form.lastName.$touch();
        if (!this.$v.form.firstName.$error && !this.$v.form.lastName.$error) {
          this.step++;
        }
      }
    },

    cancel: function() {
      this.$emit("cancel");
    },

    saveContact: function(event) {
      event.preventDefault();

      this.$v.$touch();

      if (!this.$v.$error) {
        if (this.form.id) {
          this.$emit("edit", this.form);
        } else {
          this.$emit("save", this.form);
        }
      }
    },

    awardDisplay: function(award) {
      return award.awardTitle + " (" + award.awardNumber + ")";
    },

    selectAward: function(autoselectResponse) {
      // check if award has already been added
      var found = _.find(this.form.awards, function(selectedAward) {
        return selectedAward.id === autoselectResponse.selectedObject.id;
      });
      if (!found) {
        this.form.awards.push(autoselectResponse.selectedObject);
        this.awardOptionsCopy = _.reject(this.awardOptions, function(
          awardOption
        ) {
          return awardOption.id === autoselectResponse.selectedObject.id;
        });
      }
    },

    removeAward: function(award) {
      this.form.awards = _.reject(this.form.awards, function(formAward) {
        return formAward.id === award.id;
      });
      this.awardOptionsCopy.push(award);
    },

    selectCommunityPartner: function(autocompleteResponse) {
      this.form.communityPartner = _.find(
        this.communityPartnerOptions,
        function(communityPartner) {
          return communityPartner.id === autocompleteResponse.value;
        }
      );
    },

    removeUsedAwardOptions: function(awardsToRemove) {
      this.awardOptionsCopy = _.reject(this.awardOptionsCopy, function(
        awardOption
      ) {
        var found = _.find(awardsToRemove, function(award) {
          return award.id === awardOption.id;
        });
        if (found != undefined) {
          return true;
        }
        return false;
      });
    }
  },

  created() {
    this.form.communityPartnerId = this.communityPartnerId;
    this.awardOptionsCopy = JSON.parse(JSON.stringify(this.awardOptions));

    if (this.contact) {
      this.form = JSON.parse(JSON.stringify(this.contact));
      if (this.contact.communityPartner) {
        this.communityPartnerInitialDisplay = this.contact.communityPartner.name;
      }
      this.removeUsedAwardOptions(this.contact.awards);
    }
  }
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
</style>
